export const MIN_ONE_YEAR_EXPECTED_RETURN=-0.5;export const MAX_ONE_YEAR_EXPECTED_RETURN=0.5;export const MIN_RISK=0;export const MAX_RISK=1;